import { type ColumnsType, type ColumnType } from 'antd/es/table';
import { SETTING_COLUMN_KEY } from '../addColumnPicker.tsx';
import { type ColumnPickerConfig } from '../form/ColumnPickerSchema.tsx';

export class PickableColumnUtils {
  static isEnabled() {
    return process.env.ENABLE_PICKABLE_COLUMNS === 'true';
  }

  /**
   * Funzione che divide la colonna "action" dalle altre colonne.
   */
  static divideSettingColumn(columns: Array<ColumnType<any>>) {
    const settingColumn = columns.find(c => c.key === SETTING_COLUMN_KEY);
    return {
      otherColumns: columns.filter(c => c.key !== SETTING_COLUMN_KEY),
      settingColumn,
    };
  }

  static mapPickableColumnsFromConfig<T>(props: {
    pickableConfig: ColumnPickerConfig;
    settingColumn: ColumnType<any> | undefined;
    allInputColumns: Array<ColumnType<T>>;
  }): ColumnsType<any> {
    const { pickableConfig, allInputColumns, settingColumn } = props;

    const pickedColumns = pickableConfig.columns ?? [];

    const data = pickedColumns.map(column => {
      // per ogni colonna salvata, troviamo la corrispondente colonna disponibile (originale)
      const originalColumn = allInputColumns?.find(c => c.key === column.key);
      // e impostiamo gli attributi di visualizzazione salvati
      return {
        ...originalColumn,
        hidden: !column?.visible,
        fixed: column?.fixed ? 'left' : undefined,
        showInExpandedRow: column?.showInExpandedRow,
      } as ColumnType<T>;
    });

    const result = [
      ...data,
      ...(settingColumn ? [{ ...settingColumn, fixed: 'right' as const }] : []),
    ];

    return result;
  }

  static mapDefaultColumns(props: {
    columns: Array<ColumnType<any>>;
    settingColumn: ColumnType<any> | undefined;
  }): ColumnsType<any> {
    const { columns, settingColumn } = props;

    return [
      ...columns,
      ...(settingColumn ? [{ ...settingColumn, fixed: 'right' as const }] : []),
    ];
  }
}
